<template>
  <b-container>
    <b-table
      :items="opmerkingen"
      :fields="[{ key: 'Selectie', label: '' }, 'Type', 'Opmerking']"
    >
      <template #cell(Selectie)="row">
        <b-check v-model="row.item.selected" />
      </template>
    </b-table>
    <b-button 
      :disabled="geselecteerd.length == 0" 
      class="pull-right" 
      size="sm"
      variant="danger" 
      @click="opmerkingenVerwijderen"
    >
      Verwijderen
    </b-button>
    <b-form-group 
      label="Nieuwe opmerking" 
      class="my-5"
    >
      <b-input-group prepend="Type">
        <b-input-group-prepend>
          <b-select
            v-model="item.Type"
            :options="[
              {
                value: 'OH',
                text: 'OH: Onderhoud'
              }, 
              {
                value: 'OF',
                text: 'OF: Offerte'
              }, 
              {
                value: 'PR',
                text: 'PR: Bedrag in prognose'
              }, 
              {
                value: 'PLOH',
                text: 'PLOH: Planmatig onderhoud'
              }, 
              {
                value: 'KL',
                text: 'KL: Klant'
              },
              {
                value: 'NB',
                text: 'NB: Niet bekend'
              }
            ]"
          />
        </b-input-group-prepend>
        <b-input 
          v-model="item.Opmerking" 
          placeholder="Opmerking"
        />

        <b-button 
          variant="success" 
          @click="opmerkingToevoegen"
        >
          Toevoegen
        </b-button>
      </b-input-group>
    </b-form-group>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  name: "DocumentOpmerkingen",
  mixins: [serviceMixin],
  props: {
    opmerkingen: {
      type: Array,
      default: () => []
    },
    document: {
      type: Object,
      default: () => null
    },
  },
  data() {
    return {
      item: {
        Opmerking: "",
        Type: null,
        error: null
      },
    };
  },
  computed: {
    geselecteerd: function () {
      return this.opmerkingen.filter((i) => i.selected === true);
    },
  },
  methods: {
      opmerkingToevoegen() {
          var vm = this
        this.post('/documenten/document/' + this.document.Id + '/opmerkingen',this.item).then(function (response) {
          console.log(response.data);
          vm.opmerkingen = response.data.opmerkingen;
        })
        .catch(function (error) {
          vm.error = error;
        })
        .finally(() => (vm.busy = false));
      },
      opmerkingenVerwijderen() {
        var vm = this
        this.deletePost('/documenten/document/' + this.document.Id + '/opmerkingen',{teverwijderen: this.geselecteerd}).then(function (response) {
          console.log(response.data);
          vm.opmerkingen = response.data.opmerkingen;
        })
        .catch(function (error) {
          vm.error = error;
        })
        .finally(() => (vm.busy = false));
      }
  }
};
</script>